export default __webpack_public_path__ + "static/media/logo-full.fc093435.png";